import { Dialog, DialogTitle, IconButton, DialogContent, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import ScheduleDisplay from "../../schedules/scheduleDisplay";
import CloseIcon from "@mui/icons-material/Close";


interface ScheduleModalProps {
    open: boolean
    onClose: () => void
}

export const ScheduleModal: React.FC<ScheduleModalProps> = ({ open, onClose }) => {
    const {
        selectedSchedule,
    } = useSelector((state: RootState) => state.schedule);
    return (
        <Dialog
            open={open}
            maxWidth={false}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: "80vw",
                    maxHeight: "90vh",
                    borderRadius: 3,
                },
            }}
            sx={{
                width: '100%'
            }}
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                     <Box height="100%" overflow="auto">
                        {
                        selectedSchedule != null ? <ScheduleDisplay schedule={selectedSchedule!} /> : ''
                        }
                    </Box>
                
               
            </DialogContent>
        </Dialog>
    );
};



export default ScheduleModal;